import React from "react";
import { iconProps } from "../../../Helper";

export const AIDetectorIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        className={className}
        d="M6.66683 4C4.15283 4 2.8955 4 2.11483 4.78133C1.33416 5.56267 1.3335 6.81933 1.3335 9.33333C1.3335 11.8473 1.3335 13.1047 2.11483 13.8853C2.89616 14.666 4.15283 14.6667 6.66683 14.6667H9.3335C11.8475 14.6667 13.1048 14.6667 13.8855 13.8853C14.6662 13.104 14.6668 11.8473 14.6668 9.33333C14.6668 8.55333 14.6668 7.89467 14.6435 7.33333"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        className={className}
        d="M12.0002 1.3335L12.1968 1.86483C12.4542 2.56083 12.5835 2.90883 12.8368 3.16283C13.0915 3.41683 13.4395 3.54616 14.1355 3.8035L14.6668 4.00016L14.1355 4.19683C13.4395 4.45416 13.0915 4.5835 12.8375 4.83683C12.5835 5.0915 12.4542 5.4395 12.1968 6.1355L12.0002 6.66683L11.8035 6.1355C11.5462 5.4395 11.4168 5.0915 11.1635 4.8375C10.9088 4.5835 10.5608 4.45416 9.86483 4.19683L9.3335 4.00016L9.86483 3.8035C10.5608 3.54616 10.9088 3.41683 11.1628 3.1635C11.4168 2.90883 11.5462 2.56083 11.8035 1.86483L12.0002 1.3335Z"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  );
};
